var exports = {
  "kL": "x52a3aa3b--4506bb--container",
  "nf": "x52a3aa3b--4506bb--link",
};

module.exports = exports;
